import { render } from "./PoolDetail.vue?vue&type=template&id=270935b8&scoped=true"
import script from "./PoolDetail.vue?vue&type=script&lang=js"
export * from "./PoolDetail.vue?vue&type=script&lang=js"

import "./PoolDetail.vue?vue&type=style&index=0&id=270935b8&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270935b8"],['__file',"resources/js/components/PoolDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "270935b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('270935b8', __exports__)) {
    api.reload('270935b8', __exports__)
  }
  
  module.hot.accept("./PoolDetail.vue?vue&type=template&id=270935b8&scoped=true", () => {
    api.rerender('270935b8', render)
  })

}


export default __exports__